import { ExternalLink, Newspaper } from 'lucide-react';
import { useData } from './DataContext';

export function PlayerNewsView() {
  const { officialResults } = useData();
  const latest = [...officialResults].sort((a,b) => b.match_date.localeCompare(a.match_date)).slice(0,10);

  return (
    <div className="player-readonly-page">
      <section className="metal-card player-readonly-hero">
        <div><p className="eyebrow">GDSFC / POLONIA</p><h1>News & Results</h1><p className="muted">Read-only club and league updates.</p></div>
        <Newspaper size={34}/>
      </section>
      <section className="metal-card player-news-card">
        <div className="player-section-head"><div><p className="eyebrow">LATEST</p><h2>Official GDSFC results</h2></div></div>
        <div className="player-news-results">
          {latest.map((result) => (
            <div className="player-news-result" key={result.source_key}>
              <span>{new Date(`${result.match_date}T12:00:00`).toLocaleDateString()}</span>
              <strong>{result.home_team}</strong><b>{result.home_goals}–{result.away_goals}</b><strong>{result.away_team}</strong>
            </div>
          ))}
        </div>
        <a className="steel-button player-instagram-link" href="https://www.instagram.com/gdsfc2008/" target="_blank" rel="noreferrer">
          <ExternalLink size={15}/> Open @gdsfc2008
        </a>
      </section>
    </div>
  );
}
